import { REMOVE_TOKENS_START, REMOVE_TOKENS_SUCCESS, REMOVE_TOKENS_ERROR } from './actionTypes.js';

var removeTokens = (async function (_ref) {
  var dispatch = _ref.dispatch;
    _ref.tokens;
    var tokenKey = _ref.tokenKey;
  try {
    dispatch({
      type: REMOVE_TOKENS_START,
      tokenKey: tokenKey
    });
    dispatch({
      type: REMOVE_TOKENS_SUCCESS
    });
  } catch (error) {
    dispatch({
      type: REMOVE_TOKENS_ERROR,
      error: error
    });
  }
});

export { removeTokens as default };
//# sourceMappingURL=removeTokens.js.map
